(() => {
  if (window.ctpReady) return;
  window.ctpReady = true;

  const money = (cents, format) => {
    const v = (Number(cents) || 0) / 100;
    const fix = (n, d, ts, ds) => {
      const p = n.toFixed(d).split('.');
      return p[0].replace(/\B(?=(\d{3})+(?!\d))/g, ts) + (p[1] ? ds + p[1] : '');
    };
    return String(format || '${{amount}}').replace(/\{\{\s*(\w+)\s*\}\}/, (_, k) => {
      if (k === 'amount_no_decimals') return fix(v, 0, ',', '.');
      if (k === 'amount_with_comma_separator') return fix(v, 2, '.', ',');
      if (k === 'amount_no_decimals_with_comma_separator') return fix(v, 0, '.', ',');
      if (k === 'amount_with_apostrophe_separator') return fix(v, 2, "'", '.');
      return fix(v, 2, ',', '.');
    });
  };

  const refreshBag = async (root) => {
    try {
      const res = await fetch(root.dataset.cartUrl + '.js', { headers: { Accept: 'application/json' } });
      if (!res.ok) return;
      const cart = await res.json();
      document.querySelectorAll('.ctp-bag-count').forEach((el) => { el.textContent = cart.item_count; });
    } catch (e) { /* the count is cosmetic; the item is already in the bag */ }
  };

  const addToBag = async (root, id) => {
    const res = await fetch(root.dataset.addUrl + '.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: [{ id: Number(id), quantity: 1 }] })
    });
    if (!res.ok) {
      const err = await res.json().catch(() => ({}));
      throw new Error(err.description || err.message || root.dataset.unavailable);
    }
    await refreshBag(root);
  };

  const openBag = () => {
    const btn = document.querySelector('[data-cth="bag"]');
    if (btn) btn.click();
    return !!btn;
  };

  class CtpProduct {
    constructor(root) {
      this.root = root;
      const d = root.dataset;
      this.labels = { add: d.add, added: d.added, sold: d.sold, warn: d.warn, pick: d.pick, unavailable: d.unavailable };
      this.form = root.querySelector('[data-ctp-form]');
      this.idInput = root.querySelector('[data-variant-id]');
      this.ctas = [...root.querySelectorAll('[data-cta]')];
      this.status = root.querySelector('[data-status]');
      this.groups = [...root.querySelectorAll('[data-opt]')];
      this.note = root.querySelector('[data-sticky-note]');
      try { this.variants = JSON.parse(root.querySelector('[data-variants]').textContent); } catch (e) { this.variants = []; }
      this.initGallery();
      this.initShipBy();
      this.initGuide();
      this.groups.forEach((g) => g.addEventListener('change', () => this.update(true)));
      if (this.form) this.form.addEventListener('submit', (e) => this.submit(e));
      this.initQuick(root);
      this.initRecs();
      this.update(false);
    }

    initGallery() {
      this.slides = [...this.root.querySelectorAll('.ctp-slide')];
      this.thumbs = [...this.root.querySelectorAll('[data-goto]')];
      this.counter = this.root.querySelector('[data-count]');
      this.index = Math.max(0, this.slides.findIndex((s) => s.classList.contains('is-active')));
      this.thumbs.forEach((b) => b.addEventListener('click', () => this.go(Number(b.dataset.goto))));
      const prev = this.root.querySelector('[data-prev]');
      const next = this.root.querySelector('[data-next]');
      if (prev) prev.addEventListener('click', () => this.go(this.index - 1));
      if (next) next.addEventListener('click', () => this.go(this.index + 1));
      const stage = this.root.querySelector('[data-stage]');
      if (!stage) return;
      let x0 = null; let y0 = null;
      stage.addEventListener('touchstart', (e) => { x0 = e.touches[0].clientX; y0 = e.touches[0].clientY; }, { passive: true });
      stage.addEventListener('touchend', (e) => {
        if (x0 === null) return;
        const dx = e.changedTouches[0].clientX - x0;
        const dy = e.changedTouches[0].clientY - y0;
        if (Math.abs(dx) > 40 && Math.abs(dx) > Math.abs(dy)) this.go(this.index + (dx < 0 ? 1 : -1));
        x0 = null;
      });
    }

    go(i) {
      const n = this.slides.length;
      if (n < 2) return;
      this.index = (i + n) % n;
      this.slides.forEach((s, j) => {
        const on = j === this.index;
        s.classList.toggle('is-active', on);
        if (on) s.removeAttribute('aria-hidden'); else s.setAttribute('aria-hidden', 'true');
        if (on) { const img = s.querySelector('img'); if (img) img.loading = 'eager'; }
      });
      this.thumbs.forEach((b) => {
        const on = Number(b.dataset.goto) === this.index;
        b.setAttribute('aria-current', String(on));
        if (on) b.parentElement.scrollTo({ left: b.offsetLeft - b.parentElement.offsetLeft - b.parentElement.clientWidth / 2 + b.clientWidth / 2, behavior: 'smooth' });
      });
      if (this.counter) this.counter.textContent = (this.index + 1) + ' / ' + n;
    }

    selected() {
      return this.groups.map((g) => { const c = g.querySelector('input:checked'); return c ? c.value : null; });
    }

    labelFor(i, val) {
      const out = this.groups[i].querySelector('[data-opt-value]');
      return (out ? out.dataset.prefix || '' : '') + val;
    }

    setCta(label, opts) {
      const o = opts || {};
      this.ctas.forEach((c) => {
        c.disabled = !!o.disabled;
        c.classList.toggle('is-added', !!o.added);
        const l = c.querySelector('[data-cta-label]');
        if (l) l.textContent = label;
        const p = c.querySelector('[data-cta-price]');
        if (p) p.hidden = !o.price;
      });
    }

    update(fromUser) {
      const sel = this.selected();
      const complete = sel.every((v) => v !== null);
      const variant = complete ? this.variants.find((v) => v.options.every((o, i) => o === sel[i])) || null : null;
      this.groups.forEach((g, i) => {
        g.classList.remove('is-warn');
        const out = g.querySelector('[data-opt-value]');
        if (out) out.textContent = sel[i] !== null ? this.labelFor(i, sel[i]) : this.labels.pick;
        g.querySelectorAll('.ctp-val').forEach((lab) => {
          const val = lab.querySelector('input').value;
          const ok = this.variants.some((v) => v.available && v.options[i] === val && v.options.every((o, j) => j === i || sel[j] === null || o === sel[j]));
          lab.classList.toggle('is-out', !ok);
        });
      });
      this.variant = variant;
      if (this.idInput && variant) this.idInput.value = variant.id;
      const shown = variant || this.variants.find((v) => v.available) || this.variants[0];
      if (shown) this.setPrice(shown);
      if (complete && !variant) this.setCta(this.labels.unavailable, { disabled: true });
      else if (variant && !variant.available) this.setCta(this.labels.sold, { disabled: true });
      else this.setCta(this.labels.add, { price: true });
      if (this.note) {
        const bits = sel.map((v, i) => {
          if (this.groups[i].dataset.kind === 'fixed') return null;
          return v === null ? this.labels.pick : this.labelFor(i, v);
        }).filter(Boolean);
        this.note.textContent = bits.join(' · ');
        this.note.hidden = !bits.length;
      }
      if (variant && fromUser) {
        if (variant.media) {
          const k = this.slides.findIndex((s) => s.dataset.mediaId === String(variant.media));
          if (k > -1) this.go(k);
        }
        const url = new URL(window.location.href);
        url.searchParams.set('variant', variant.id);
        window.history.replaceState({}, '', url.toString());
      }
    }

    setPrice(v) {
      const sale = !!v.compare && v.compare > v.price;
      const off = sale ? Math.round(((v.compare - v.price) * 100) / v.compare) : 0;
      const fmt = (c) => money(c, this.root.dataset.money);
      const put = (sel, text, show) => this.root.querySelectorAll(sel).forEach((el) => { el.textContent = text; el.hidden = !show; });
      put('[data-price]', fmt(v.price), true);
      put('[data-was]', sale ? fmt(v.compare) : '', sale);
      put('[data-save]', sale ? 'Save ' + fmt(v.compare - v.price) : '', sale);
      put('[data-off]', '-' + off + '%', sale);
      this.root.querySelectorAll('[data-sale-mark]').forEach((el) => el.classList.toggle('is-sale', sale));
      this.root.querySelectorAll('[data-cta-price]').forEach((el) => { el.textContent = ' · ' + fmt(v.price); });
    }

    say(t) {
      if (!this.status) return;
      this.status.textContent = '';
      requestAnimationFrame(() => { this.status.textContent = t; });
    }

    warn() {
      const g = this.groups.find((x) => !x.querySelector('input:checked'));
      if (g) {
        g.classList.add('is-warn');
        const out = g.querySelector('[data-opt-value]');
        if (out) out.textContent = this.labels.warn;
        g.scrollIntoView({ behavior: 'smooth', block: 'center' });
        const first = g.querySelector('.ctp-val:not(.is-out) input');
        if (first) first.focus({ preventScroll: true });
      }
      this.setCta(this.labels.warn);
      this.say(this.labels.warn);
    }

    async submit(e) {
      e.preventDefault();
      if (!this.variant) { this.warn(); return; }
      if (!this.variant.available) return;
      this.ctas.forEach((c) => { c.disabled = true; });
      clearTimeout(this.t);
      try {
        await addToBag(this.root, this.variant.id);
        if (this.root.dataset.afterAdd === 'cart') { window.location.href = this.root.dataset.cartUrl; return; }
        openBag();
        this.setCta(this.labels.added, { added: true });
        this.say(this.labels.added);
        this.t = setTimeout(() => this.update(false), 1600);
      } catch (err) {
        this.setCta(err.message);
        this.say(err.message);
        this.t = setTimeout(() => this.update(false), 2600);
      }
    }

    initQuick(scope) {
      scope.querySelectorAll('[data-ctp-quick]').forEach((f) => {
        f.addEventListener('submit', async (e) => {
          e.preventDefault();
          const btn = f.querySelector('button');
          const plus = btn.querySelector('.ctp-card__plus');
          const lbl = btn.querySelector('.ctp-card__lbl');
          const was = [plus.textContent, lbl.textContent];
          btn.disabled = true;
          try {
            await addToBag(this.root, f.querySelector('[name=id]').value);
            plus.textContent = '✓'; lbl.textContent = 'Added ✓';
            openBag();
          } catch (err) {
            plus.textContent = '!'; lbl.textContent = this.labels.unavailable;
          }
          setTimeout(() => { plus.textContent = was[0]; lbl.textContent = was[1]; btn.disabled = false; }, 1600);
        });
      });
    }

    async initRecs() {
      const box = this.root.querySelector('[data-recs]');
      if (!box || !box.dataset.url) return;
      try {
        const res = await fetch(box.dataset.url);
        if (!res.ok) return;
        const doc = new DOMParser().parseFromString(await res.text(), 'text/html');
        const row = doc.querySelector('.ctp-look__row');
        if (!row || !row.children.length) return;
        box.querySelector('.ctp-look__row').replaceWith(row);
        box.hidden = false;
        this.initQuick(box);
      } catch (e) { /* section stays hidden */ }
    }

    initShipBy() {
      this.root.querySelectorAll('[data-ship-by]').forEach((el) => {
        const d = new Date();
        let n = parseInt(el.dataset.days, 10) || 0;
        while (n > 0) { d.setDate(d.getDate() + 1); if (d.getDay() !== 0 && d.getDay() !== 6) n -= 1; }
        el.textContent = d.toLocaleDateString(document.documentElement.lang || undefined, { weekday: 'short', month: 'short', day: 'numeric' });
        const wrap = el.closest('[data-ship-wrap]');
        if (wrap) wrap.hidden = false;
      });
    }

    initGuide() {
      const dlg = this.root.querySelector('[data-guide]');
      if (!dlg) return;
      this.root.querySelectorAll('[data-guide-open]').forEach((b) => b.addEventListener('click', () => dlg.showModal()));
      dlg.querySelectorAll('[data-guide-close]').forEach((b) => b.addEventListener('click', () => dlg.close()));
      dlg.addEventListener('click', (e) => { if (e.target === dlg) dlg.close(); });
    }
  }

  const boot = (scope) => scope.querySelectorAll('[data-ctp-product]').forEach((el) => { if (!el.ctp) el.ctp = new CtpProduct(el); });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => boot(document));
  else boot(document);
  document.addEventListener('shopify:section:load', (e) => boot(e.target));
})();
